import { Question_Type, useQuestionSubtypesQuery } from "@generated/graphql";
import AutocompleteControl from "components/form/AutocompleteControl";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

interface QuestionSubtypeSelectProps {
  questionType: Question_Type;
  questionTypeFieldName?: string;
  questionSubtypeFieldName?: string;
  disabled?: boolean;
}

const QuestionSubtypeSelect = ({
  questionType,
  questionTypeFieldName = "questionType",
  questionSubtypeFieldName = "questionSubtype",
  disabled,
}: QuestionSubtypeSelectProps) => {
  const { data: questionSubtypesData, loading: questionSubtypesLoading } = useQuestionSubtypesQuery({
    variables: { questionType: [questionType] },
  });

  const subtypes = questionSubtypesData?.questionSubtypes[0]?.subtypes;

  const { watch, setValue } = useFormContext();
  const questionSubTypeWatch = watch(questionSubtypeFieldName) as string;

  useEffect(() => {
    if (subtypes && !subtypes.includes(questionSubTypeWatch)) {
      setValue(questionSubtypeFieldName, null);
    }
  }, [subtypes]);

  return (
    <AutocompleteControl
      name={questionSubtypeFieldName}
      options={subtypes || []}
      loading={questionSubtypesLoading}
      label='Подтип'
      disabled={disabled}
      rules={{
        validate: (value, formValues) => {
          const isPracticalOrMultipleChoiceQuestion =
            formValues[questionTypeFieldName].id === Question_Type.Practical ||
            formValues[questionTypeFieldName].id === Question_Type.MultipleChoiceQuestions;
          return !(isPracticalOrMultipleChoiceQuestion && !value);
        },
      }}
    />
  );
};

export default QuestionSubtypeSelect;
